import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import Queries from "../../queries/queries2";
import Spinner from "../../elements/Spinner/Spinner";
import SupplierForm from "./SupplierForm";
import _ from "lodash";
import { getTiersXtraData, setTiersXtraData } from "../../tools/tiersExtraData";

class SupplierEdit extends Component {
  constructor(props) {
    super(props);
    if (props.getSupplierQuery.tiers) {
      this.state = this.getStateObject(props.getSupplierQuery.tiers);
    } else {
      this.state = { supplier: null };
    }

    props.getSupplierQuery.refetch();
  }
  getStateObject({
    id,
    addresses,
    company,
    currency,
    group,
    iban,
    name,
    swift,
    website,
    supplier,
    xtraData
  }) {
    let contacts = [];
    supplier &&
      supplier.contacts &&
      supplier.contacts.map(contact => {
        const newContact = {
          id: contact.id,
          email: contact.email,
          job: contact.job,
          name: contact.name,
          telFixe: contact.telFixe,
          telMobile: contact.telMobile,
          clientId: null
        };
        contacts.push(newContact);
        return newContact;
      });

    console.log("SupplierEdit getStateObject");
    console.log("addresses", addresses);
    return {
      supplier: {
        id,
        address: (addresses && addresses.length > 0) ? addresses[0].address : "",
        addressId: (addresses && addresses.length > 0) ? addresses[0].id : null,
        country:
          addresses && addresses.length > 0 && addresses[0].country
            ? addresses[0].country.id
            : null,
        company: company ? company.id : "",
        currency: currency ? currency.id : "",
        iban: iban ? iban : "",
        group,
        taxableValue: xtraData ? getTiersXtraData(xtraData).taxable : null,
        externalCodeValue: xtraData ? getTiersXtraData(xtraData).externalCode : null,
        escomptePercentValue: xtraData ? getTiersXtraData(xtraData).escomptePercent : null,
        name,
        swift,
        website,
        contacts,
        codeAPE: (supplier && supplier.codeAPE) || "",
        tax1: supplier.defaultTax1,
        tax2: supplier.defaultTax2,
        taxIdemCompany: supplier.taxIdemCompany,
        defaultTermDelaisPaiement:
          (supplier && supplier.defaultTermDelaisPaiement) || "",
        defaultTermNetsFinDeMois:
          (supplier && supplier.defaultTermNetsFinDeMois) || "",
        numeroTVA: (supplier && supplier.numeroTVA) || "",
        siret: supplier && supplier.siret ? supplier.siret : ""
      }
    };
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.getSupplierQuery.tiers &&
      prevProps.getSupplierQuery.tiers !== this.props.getSupplierQuery.tiers
    ) {
      this.setState(this.getStateObject(this.props.getSupplierQuery.tiers));
    }
  }
  createUpdateAndDeleteContacts = async values => {
    const formerContactList =
      (this.props.getSupplierQuery.tiers &&
        this.props.getSupplierQuery.tiers.supplier &&
        this.props.getSupplierQuery.tiers.supplier.contacts) ||
      [];
    let newContactList = [];
    await Promise.all(
      values.contacts.map(async contact => {
        const formerContact = _.find(formerContactList, { id: contact.id });
        if (!formerContact) {
          const c = {
            ...contact,
            companyId: this.props.companyDefaultInfos.company.id,
            supplierId: this.props.getSupplierQuery.tiers.supplier.id
          };
          const contact_created = await this.props.createContact({
            variables: c
          });

          await newContactList.push(contact_created.data.createContact);
        } else if (formerContact !== contact) {
          const c = {
            ...contact,
            companyId: this.props.companyDefaultInfos.company.id
          };
          const contact_updated = await this.props.updateContact({
            variables: c
          });

          await newContactList.push(contact_updated.data.updateContact);
        }
      })
    );
    const deleteContacts = (newContactList, formerContactList) => {
      if (newContactList.length !== formerContactList.length) {
        var ids = _.differenceWith(
          _.map(formerContactList, "id"),
          _.map(newContactList, "id"),
          _.isEqual
        );
        ids.map(id => this.props.deleteContact({ variables: { id } }));
      }
    };
    await deleteContacts(newContactList, formerContactList);
    return newContactList;
  };
  onSubmit = async values => {
    if (values && values.name === "")
      return;

    // console.log("140 - values=", values);

    const newContactList = await this.createUpdateAndDeleteContacts(values);
    const submit = (newContactList, values) => {
      if (values.contacts.length === newContactList.length) {
        this.props.onSubmit(values);
      }
    };

    values["disconnectTax1"] = !!(!values.tax1 && this.state.supplier.tax1);
    values["connectTax1"] = !!(
      values.tax1 && values.tax1 !== this.state.supplier.tax1
    );
    values["disconnectTax2"] = !!(!values.tax2 && this.state.supplier.tax2);
    values["connectTax2"] = !!(
      values.tax2 && values.tax2 !== this.state.supplier.tax2
    );
    if (
      !this.state.supplier.taxIdem &&
      values.taxIdemCompany &&
      !!this.state.supplier.tax1 &&
      !!this.state.supplier.tax2
    ) {
      values["disconnectTax1"] = true;
      values["disconnectTax2"] = true;
    }
    if (values.taxIdemCompany) {
      values["connectTax1"] = !!values.tax1;
      values["connectTax2"] = !!values.tax2;
    }

    // xtraData
    values["xtraData"] = setTiersXtraData(this.props.xtraData, values.taxableValue, values.externalCodeValue, values.escomptePercentValue)

    values["supplierId"] = this.props.getSupplierQuery.tiers.supplier.id;

    // console.log("173 - values=", values);    
    submit(newContactList, values);
  };

  deleteSupplier = async () => {
    console.log(">> onDelete...", this.props.getSupplierQuery.tiers);

    const deleted = await this.props.deleteTiers_Supplier({
      variables: this.props.getSupplierQuery.tiers
    });

    return deleted;
  };

  render() {
    const companyId =
      this.props.getSupplierQuery.tiers &&
      this.props.getSupplierQuery.tiers.company.id;

    // console.log("200 - SupplierEdit render", this.state.supplier);
    if (this.state.supplier) {
      return (
        <SupplierForm
          companyId={companyId}
          sendNotification={this.props.sendNotification}
          cancel={this.props.cancel}
          inSideModal={this.props.inSideModal}
          supplier={this.state.supplier}
          companyDefaultInfos={this.props.companyDefaultInfos}
          getDefaultCountry={this.props.getDefaultCountry}
          companyId={companyId}
          onSubmit={values => this.onSubmit(values)}
          deleteSupplier={this.deleteSupplier}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
          checkDelete={this.props.checkOnlyDeleteTiers_Supplier}
        />
      );
    }
    return <Spinner size="lg" fullScreen />;
  }
}

export default compose(
  graphql(Queries.GET_SUPPLIER, { name: "getSupplierQuery" }),
  graphql(Queries.CREATE_SUPPLIER_CONTACT_MUTATION, { name: "createContact" }),
  graphql(Queries.UPDATE_CONTACT_MUTATION, { name: "updateContact" }),
  graphql(Queries.DELETE_CONTACT_MUTATION, { name: "deleteContact" }),
  graphql(Queries.DELETE_TIERS_MUTATION, { name: "deleteTiers_Supplier" }),
  graphql(Queries.CHECK_ONLY_DELETE_TIERS, { name: "checkOnlyDeleteTiers_Supplier" })
)(SupplierEdit);
